<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Добавить заказчика
        </div>
        <DataEntryForCustomers :buttonName="'Добавить'" @apply="apply"/>
    </div>
</template>

<script>
import DataEntryForCustomers from "./DataEntryForCustomers";
import {v4 as uuidv4} from 'uuid';
import SVGModalClose from "../../../SVG/SVGModalClose";


export default {
    name: "AddCustomer",
    components: {
        SVGModalClose,
        DataEntryForCustomers
    },
    methods: {
        async apply(dataNewCustomer) {
            dataNewCustomer.uuid = uuidv4();
            await this.$store.dispatch('adminPanel/customers/SAVE_CUSTOMER', dataNewCustomer);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>
